export default {
  settingscheckin: [],
  listcheckin: [],
  listparticipantcheckin: [],
  pagination: {},
  settingcheckin: {}
}
